import _styled from "styled-components";
const _excluded = ["className", "style", "variant", "color", "height", "width"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { variantSwitch } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const VARIANTS = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
const COLORS = {
  SUBTLE: theme.tokens.colors.border.subtler.value,
  LIGHT: theme.tokens.colors.border.subtle.value,
  DARK: theme.tokens.colors.border.value
};
/**
 * A Divider component. Used to divide context horizontally or vertically.
 */
const Divider = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      className,
      style,
      variant = VARIANTS.HORIZONTAL,
      color = COLORS.LIGHT,
      height,
      width
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledHr, _extends({}, props, {
    ref: ref,
    className: className,
    "aria-orientation": variant,
    $_css: [{
      display: 'block',
      backgroundColor: color,
      border: 0,
      margin: 0
    }, variantSwitch({
      statement: variant,
      variants: {
        [VARIANTS.HORIZONTAL]: {
          width: width !== null && width !== void 0 ? width : '100%',
          height: height !== null && height !== void 0 ? height : 1
        },
        [VARIANTS.VERTICAL]: {
          height: height !== null && height !== void 0 ? height : '100%',
          width: width !== null && width !== void 0 ? width : 1
        }
      }
    }), style]
  }));
});
Divider.displayName = 'Divider';
Divider.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The style variant - horizontal or vertical */
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
  /** The divider color, either a string or one of Divider.COLORS */
  color: PropTypes.string,
  /** Divider width. Default to 100% for horizontal dividers */
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Divider height. Default to 100% for vertical dividers */
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default Object.assign(Divider, {
  VARIANTS,
  COLORS
});
var _StyledHr = _styled("hr").withConfig({
  displayName: "Divider___StyledHr",
  componentId: "sc-gdi66h-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Divider.js.map